import './common/global.ts';
import './common/deletion-modal';


// WEBPACK FOOTER //
// ./~/source-map-loader!./Frontend/javascript/main.ts